const removeTags = (str) => {
    const div = document.createElement('div');
    div.innerHTML = str;
    return div.innerText;
};

const nl2br = (str) => {
    if (!str) return '';
    return str.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>');
};

const br2nl = (str) => {
    if (!str) return '';
    return str.replace(/<\s*\/?br\s*[\/]?>/gi, '\n');
};

const specialChars = '/\\^();=><|{}`~';
const sanitise = (str) => {
    let result = removeTags(str);
    [...specialChars].forEach((sc) => {
        result = result.replace(sc, '');
    });
    return result;
};

export { removeTags, nl2br, br2nl, sanitise };
